import { defineMessages } from 'react-intl';

const messages = defineMessages({
  continue: {
    id: 'player.endscreen.continue',
    defaultMessage: 'Continue',
  },
  start: {
    id: 'player.endscreen.start',
    defaultMessage: 'Start',
  },
  nextVideo: {
    id: 'player.endscreen.next',
    defaultMessage: 'Next {type}:',
  },
  nextPracticeSheet: {
    id: 'player.endscreen.nextPracticeSheet',
    defaultMessage: 'Up Next:',
  },
  watchAgain: {
    id: 'player.endscreen.watchAgain',
    defaultMessage: 'Watch Again',
  },
  completedVideoMessage: {
    id: 'player.endscreen.completedVideoMessage',
    defaultMessage: "You've watched all of {video} {type}.",
  },
  playingInCountdown: {
    id: 'player.endscreen.playingInCountdown',
    defaultMessage: 'Playing in {secondsRemaining} seconds...',
  },
  practiceSheetMessage: {
    id: 'player.endscreen.practiceSheetMessage',
    defaultMessage: 'Practice It: {type}',
  },
});

export default messages;
